import type { Theme } from '@mui/material';

export const wrapper = (theme: Theme) => ({
	maxWidth: '120rem',
	marginBottom: '2.5rem',
	padding: '0 1.25rem',
	display: 'grid',
	width: '100%',
	gridTemplateColumns: '100%',
	gridTemplateRows: 'repeat(3, auto)',
	[theme.breakpoints.up('md')]: {
		gridTemplateColumns: 'calc( 200% / 3)   1fr',
		gridTemplateRows: 'auto 1fr',
		rowGap: '0',
		columnGap: '1rem',
		padding: '3.75rem 2%',
		marginBottom: '3.75rem',
		gridTemplateAreas: '"media header" "media content"',
	},
	[theme.breakpoints.up('lg')]: {
		padding: '3.75rem 5%',
	},
});

// parent component container adds a padding to whole
// but this particular one is to override with margin so that it will be stretched to full
export const mediaSliderStylesSection = (theme: Theme) => ({
	[theme.breakpoints.down('md')]: {
		margin: '0 -1.5rem',
	},
	[theme.breakpoints.up('md')]: {
		gridArea: 'media',
	},
});

export const headerSectionStyles = {
	gridArea: { md: 'header' },
};

export const groupedContentStyles = {
	gridArea: { md: 'content' },
};

export const disclaimerWrapperStyles = {
	'&.MuiContainer-root': {
		paddingX: '0',
	},
	paddingY: '1.25rem',
};
